import { filter } from 'lodash';
import { withStyles, createStyles, makeStyles } from '@material-ui/styles';
import { useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import {
  Card,
  Table,
  TableRow,
  TableBody,
  TableCell,
  Container,
  TableContainer,
  TablePagination,
  IconButton,
  Divider,
  Typography,
  TextField,
  Grid,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Backdrop,
  CircularProgress,
  Select
} from '@material-ui/core';
import moment from 'moment';
import { CSVLink } from 'react-csv';
import RefreshIcon from '@material-ui/icons/Refresh';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import { baseUrl } from '../../utils/constants';
import Scrollbar from '../Scrollbar';
import SearchNotFound from '../SearchNotFound';
import { ClientListHead } from '../_dashboard/clients';
import { useConstantsContext } from '../../context/constants_context';
import Controls from '../controls/Controls';

const useStyles = makeStyles(() => ({
  markVerified: {
    backgroundColor: '#2979ff ',
    color: 'white'
  },
  markUnverified: {
    backgroundColor: '#ff5252',
    color: 'black'
  },
  tableFooter: {
    backgroundColor: 'black',
    color: 'white',
    size: 'small'
  }
}));

const StyledTableRow = withStyles((theme) =>
  createStyles({
    root: {
      '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover
      }
    }
  })
)(TableRow);

const TABLE_HEAD = [
  { id: 'acc', label: 'Account #', alignRight: true },
  { id: 'provider', label: 'Member', alignRight: false },
  { id: 'Totade', label: 'Credit Total', alignRight: true },
  { id: 'tod', label: 'Debit Total', alignRight: true },
  { id: 'bals', label: 'Balance', alignRight: true }
];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    return filter(
      array,
      (_doc) => _doc.documentType.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function Defaults() {
  const m = moment();
  const { payCycles } = useConstantsContext();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState('asc');
  const [selected, setSelected] = useState([]);
  const [begDate, setBegDate] = useState(49);
  const [dataList, setDataList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [docType, setDocType] = useState('pdf');
  const [orderBy, setOrderBy] = useState('documentType');
  const [filterName, setFilterName] = useState('');
  const [payCycle, setPayCycle] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(8);
  const [notify, setNotify] = useState({ isOpen: false, message: '', type: 'success' });
  console.log('paycycles nonn non now', payCycles);
  console.log('paycycles selected', payCycle);
  const filename = `MemberSubsBalances_${moment().format('DD-MMM-YYYY')}.${docType}`;
  const navigate = useNavigate();
  const classes = useStyles();

  useEffect(() => {
    // getDefaultedPayments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    console.log('begDate in useEffect', begDate);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataList]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const openView = () => {
    navigate('/clientportfolio/portfolio');
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - dataList.length) : 0;

  const filteredUsers = applySortFilter(dataList, getComparator(order, orderBy), filterName);

  const isListEmpty = filteredUsers.length === 0;

  const getDefaultedPayments = () => {
    setLoading(true);
    fetch(`${baseUrl}/api/accounting/getDefaultedPayments?payCycle=${payCycle}`)
      .then((res) => res.json())
      .then(
        (result) => {
          console.log('returned getDefaultedPayments Summary list', result);
          setDataList(result);
          setLoading(false);
        },
        (error) => {
          setLoading(false);
          notifyPopup(`Error getting getDefaultedPayments!: ${error}`, 'error');
        }
      );
  };

  const downloadDocument = () => {
    setLoading(true);
    fetch(`${baseUrl}/api/report/getnew/DefaultsSsb/${docType}/0/0/1/${payCycle}/1`)
      .then((response) => response.blob())
      .then(
        (blob) => {
          const url = window.URL.createObjectURL(new Blob([blob]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', `${filename}`);
          document.body.appendChild(link);
          link.click();
          link.parentNode.removeChild(link);
          setLoading(false);
        },
        (error) => {
          notifyPopup(`Error in Downloading Claims by Provider!: ${error}`, 'error');
        }
      );
  };

  const notifyPopup = (notifyMessage, notifyType) => {
    setNotify({
      isOpen: true,
      message: `${notifyMessage}`,
      type: `${notifyType}`
    });
  };

  const handleLoadingClose = () => {
    setLoading(false);
  };

  const sendSmss = () => {
    notifyPopup(`Not enough Units to send Unpaid Subs SMSs!`, 'error');
  };

  return (
    <Container>
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
        onClick={handleLoadingClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Grid container spacing={4}>
        <Grid item xs={5} sm={3}>
          <Typography component="span" variant="h4" gutterBottom>
            Unpaid Subscriptions
          </Typography>
        </Grid>
        <Grid item xs={12} sm={2}>
          <FormControl fullWidth>
            <InputLabel id="terms">Period Month</InputLabel>
            <Select
              name="cycle"
              value={payCycle}
              fullWidth
              size="small"
              variant="outlined"
              onChange={(e) => {
                setPayCycle(e.target.value);
              }}
            >
              <MenuItem key="" value="0">
                Not Selected
              </MenuItem>
              {payCycles.map((item) => (
                <MenuItem key={item.payCycleId} value={item.payCycleId}>
                  {moment(item.payDate).format('YYYY-MM-DD')}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={1}>
          <FormControl className={classes.formControl}>
            <InputLabel id="selectDoc">Doc Type</InputLabel>
            <Select
              labelId="selectDoclabel"
              id="docType"
              value={docType}
              size="small"
              onChange={(e) => {
                setDocType(e.target.value);
              }}
            >
              <MenuItem value="pdf">PDF</MenuItem>
              <MenuItem value="xls">XLS</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={2}>
          <Button
            type="button"
            variant="outlined"
            startIcon={<RefreshIcon />}
            onClick={() => getDefaultedPayments()}
          >
            Refresh
          </Button>
        </Grid>
        <Grid item xs={12} sm={2} ml={2}>
          <Button
            type="button"
            variant="outlined"
            startIcon={<CloudDownloadIcon />}
            onClick={() => downloadDocument()}
          >
            Download
          </Button>
        </Grid>
        <Grid item xs={12} sm={2} ml={2}>
          <Button
            type="button"
            variant="outlined"
            startIcon={<CloudDownloadIcon />}
            onClick={() => sendSmss()}
          >
            Send SMSs
          </Button>
        </Grid>
      </Grid>

      <Divider style={{ background: '#832025', height: 2, margin: 10 }} variant="middle" />

      <Card>
        <Scrollbar>
          <TableContainer sx={{ minWidth: 800 }}>
            <Table size="small" aria-label="a dense table">
              <ClientListHead
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={dataList.length}
                numSelected={selected.length}
                onRequestSort={handleRequestSort}
              />
              <TableBody>
                {filteredUsers
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => {
                    /* eslint-disable camelcase */
                    const { accountNumber, accountName, totalDebit, totalCredit, balance } = row;
                    const isItemSelected = selected.indexOf(accountNumber) !== -1;

                    return (
                      <StyledTableRow
                        hover
                        key={accountNumber}
                        tabIndex={-1}
                        role="checkbox"
                        selected={isItemSelected}
                        aria-checked={isItemSelected}
                      >
                        <TableCell padding="checkbox" />

                        <TableCell align="right">{accountNumber}</TableCell>
                        <TableCell align="left">{accountName}</TableCell>
                        <TableCell align="right">{totalCredit.toFixed(2)}</TableCell>
                        <TableCell align="right">{totalDebit.toFixed(2)}</TableCell>
                        <TableCell align="right">{balance.toFixed(2)}</TableCell>
                      </StyledTableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 53 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
              {isListEmpty && (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                      <SearchNotFound searchQuery={filterName} />
                    </TableCell>
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
          <Controls.Notification notify={notify} setNotify={setNotify} />
        </Scrollbar>

        <TablePagination
          className={classes.tableFooter}
          rowsPerPageOptions={[8, 16, 24]}
          component="div"
          count={dataList.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Card>
    </Container>
  );
}
